import { http } from '../../config/axios'

export default function getResultadoMotorCredito(): Promise<any[]> {
  return http
    .get('api/resultadomotorcredito')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getResultadoMotorCredito', error)
      throw Error(error.response.data)
    })
}
